/**
 * 对字节数组进行异或操作
 * @param {Uint8Array} bytes - 要异或的字节数组
 * @param {number} value - 异或值
 * @returns {Uint8Array} - 异或后的字节数组
 */
export function xorBytes(bytes, value) {
  // 处理负数值，转换为0-255范围
  if (value < 0) {
    value &= 255;
  }
  
  const result = new Uint8Array(bytes.length);
  
  for (let i = 0; i < bytes.length; ++i) {
    let iData;
    
    // 处理负数字节值，转换为无符号整数
    if (bytes[i] < 0) {
      iData = bytes[i] & 255;
    } else {
      iData = bytes[i];
    }
    
    // 执行异或操作
    result[i] = iData ^ value;
  }
  
  return result;
}

/**
 * 对Buffer或Uint8Array进行异或操作
 * @param {Buffer|Uint8Array} buffer - 要异或的Buffer或Uint8Array
 * @param {number} value - 异或值
 * @returns {Uint8Array} - 异或后的字节数组
 */
export function xorBuffer(buffer, value) {
  // 确保输入是Uint8Array
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  const result = xorBytes(bytes, value);
  return result;
}

/**
 * 对hex字符串进行异或操作
 * @param {string} hexString - hex字符串
 * @param {number} value - 异或值
 * @returns {string} - 异或后的hex字符串
 */
export function xorHexString(hexString, value) {
  // 移除空格并确保是偶数长度
  const cleanHex = hexString.replace(/\s/g, '');
  if (cleanHex.length % 2 !== 0) {
    throw new Error('Hex string must have even length');
  }
  
  // 转换为字节数组
  const bytes = new Uint8Array(cleanHex.length / 2);
  for (let i = 0; i < cleanHex.length; i += 2) {
    bytes[i / 2] = parseInt(cleanHex.substr(i, 2), 16);
  }
  
  // 执行异或操作
  const result = xorBytes(bytes, value);
  
  // 转换回hex字符串
  return Array.from(result).map(b => b.toString(16).padStart(2, '0')).join(' ');
} 